module.exports = __webpack_public_path__ + "img/3670089.94a14f8e.png";